import React, { Fragment } from 'react'
import { useTheme } from '@mui/material';
import Grid from '@mui/material/Grid'
import Typography from '@mui/material/Typography'
import Button from '@mui/material/Button'
import { Link, Redirect } from 'react-router-dom'
import SearchIcon from '@mui/icons-material/Search'
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward'
import IconButton from '@mui/material/IconButton'
import { Link as LinkScroll } from 'react-scroll'
import Card from '@mui/material/Card'
import CardContent from '@mui/material/CardContent'
import CardMedia from '@mui/material/CardMedia'
import useMediaQuery from '@mui/material/useMediaQuery'
import { useSelector } from 'react-redux'
import landing1 from '../assets/landing1.jpg'
import customize from '../assets/landing-page/customize.jpg'
import pay from '../assets/landing-page/pay.jpg'
import time from '../assets/landing-page/time.jpg'
import chooseTeacher from '../assets/landing-page/chooseTeacher.jpg'
import schedule from '../assets/landing-page/schedule.jpg'
import startToLearn from '../assets/landing-page/start-to-learn.jpg'
import { RootState } from '../reducers/index';
import styled from "@emotion/styled";

const GridWrapper = styled(Grid)`
background-image: url(${landing1});
background-position: center;
background-size: cover;
background-repeat: no-repeat;
height: 100vh;
width: 100%;
padding: 0 1em;
`

const OverlayLayer = styled.div`
position: absolute;
left: 0;
top: 0;
width: 100%;
height: 100vh;
background-color: rgba(0,0,0,0.5);
`

const LinkScrollGridWrapper = styled(Grid)`
position: absolute;
bottom: 2em;
justify-content: center;
align-items: center;
width: 2.5em;
height: 2.5em;
border-radius: 50%;
background-color: #eee;
`

const Container = styled<any>(Grid)(({ theme }) => ({
  padding: '0 1em',
  [theme.breakpoints.up('sm')]: {
    padding: '0 3em',
  }
}))

const Landing = () => {
  const theme = useTheme()
  const matchesSM = useMediaQuery(theme.breakpoints.up('sm'))
  const matchesMD = useMediaQuery(theme.breakpoints.up('md'))
  const matchesLG = useMediaQuery(theme.breakpoints.up('lg'))

  const auth = useSelector((state: RootState) => state.auth)
  const { isAuthenticated, user } = auth

  if (isAuthenticated && user['role'] === 'user') {
    return <Redirect to="/dashboard" />
  }

  if (isAuthenticated && user['role'] === 'teacher') {
    return <Redirect to="/teachers/dashboard" />
  }

  if (isAuthenticated && user['role'] === 'admin') {
    return <Redirect to="/admin/dashboard" />
  }

  return (
    <Fragment>
      <GridWrapper
        container
        direction="row"
        justifyContent="center"
        alignItems="center"
      >
        <Grid item>
          <OverlayLayer />
        </Grid>
        <Grid
          container
          item
          direction="column"
          style={{
            maxWidth: '60em',
            zIndex: 1,
            textAlign: 'center',
            paddingRight: matchesSM ? '1em' : undefined,
            paddingLeft: matchesSM ? '1em' : undefined,
          }}
        >
          <Grid item>
            <Typography
              variant="h3"
              gutterBottom
              style={{
                color: 'white',
                fontWeight: matchesSM ? 700 : 500,
                textTransform: 'uppercase',
                fontSize: '2.5rem',
                padding: '0 0.2em',
              }}
            >
              Trở nên thành thạo tiếng Anh
            </Typography>
            <Typography
              variant="body2"
              gutterBottom
              style={{
                color: 'white',
                fontSize: matchesSM ? '1.5rem' : '1.5rem',
              }}
            >
              Hãy chọn một giáo viên dạy 1 kèm 1 dựa vào mục tiêu và sở thích
              của bạn.
            </Typography>
          </Grid>
          <Grid item container justifyContent="center" alignItems="center">
            <Button
              variant="contained"
              component={Link}
              color="primary"
              size="large"
              style={{ color: 'white', padding: '1em 2em', fontSize: '1rem' }}
              to="/teachers/english"
            >
              Tìm một giáo viên
              <SearchIcon style={{ marginLeft: '5px', fontSize: '2rem' }} />
            </Button>
          </Grid>
        </Grid>

        <LinkScrollGridWrapper item>
          <Grid item>
            <LinkScroll
              activeClass="active"
              to="why-choose-youspeak"
              spy={true}
              smooth={true}
              offset={-72}
              duration={500}
            >
              <IconButton size="large">
                <ArrowDownwardIcon style={{ fontSize: '1rem' }} />
              </IconButton>
            </LinkScroll>
          </Grid>
        </LinkScrollGridWrapper>
      </GridWrapper>

      {/* Why YouSpeak */}
      <Container
        id="why-choose-youspeak"
        container
        direction="column"
        alignItems="center"
        justifyContent="center"
        style={{
          paddingTop: '5em',
          margin: 'auto',
        }}
      >
        <Grid item>
          <Typography
            variant="h4"
          >
            Tại sao chọn YouSpeak?
          </Typography>
        </Grid>
        <Grid
          item
          container
          direction={matchesLG ? 'row' : 'column'}
          justifyContent="center"
          alignItems="center"
          spacing={4}
          style={{ margin: 0, maxWidth: matchesSM ? '80%' : '100%' }}
        >
          <Grid item lg={4}>
            <Card>
              <CardMedia
                component="img"
                alt="Cá nhân hóa việc học"
                image={customize}
              />
              <CardContent>
                <Typography gutterBottom variant="h6" component="h2">
                  Cá nhân hóa việc học
                </Typography>
                <Typography variant="body1" color="textSecondary" component="p">
                  Chọn một giáo viên cho bài học 1 kèm 1, tùy theo mục tiêu và
                  sở thích của bạn.
                </Typography>
              </CardContent>
            </Card>
          </Grid>
          <Grid item lg={4}>
            <Card>
              <CardMedia
                component="img"
                alt="thanh toán trên mỗi bài học"
                image={pay}
              />
              <CardContent>
                <Typography gutterBottom variant="h6" component="h2">
                  Thanh toán trên mỗi bài học
                </Typography>
                <Typography variant="body1" color="textSecondary" component="p">
                  Bạn sẽ chỉ thanh toán sau mỗi bài học với mức giá phù hợp với
                  ngân sách của bạn.
                </Typography>
              </CardContent>
            </Card>
          </Grid>
          <Grid item lg={4}>
            <Card>
              <CardMedia
                component="img"
                alt="Tùy ý chọn thời gian và địa điểm"
                image={time}
              />
              <CardContent>
                <Typography gutterBottom variant="h6" component="h2">
                  Tùy ý chọn thời gian và địa điểm.
                </Typography>
                <Typography variant="body1" color="textSecondary" component="p">
                  Chọn giờ học vào thời điểm phù hợp với bạn.
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </Container>
      {/* How it works */}
      <Container
        container
        alignItems="center"
        direction="column"
        style={{
          marginTop: '5em',
          paddingBottom: '5em',
        }}
      >
        <Grid item>
          <Typography
            variant="h4"
          >
            Cách học trên YouSpeak
          </Typography>
        </Grid>

        <Container
          container
          item
          justifyContent="space-between"
          alignItems="center"
          style={{ marginTop: '2em', width: '100%' }}
        >
          <Grid item md={5}>
            <img
              src={chooseTeacher}
              alt="Chọn giáo viên"
              style={{ maxWidth: '100%' }}
            />
          </Grid>
          <Grid item md={5}>
            <Grid container direction="column">
              <Grid item>
                <p style={{ textTransform: 'uppercase', fontWeight: 600 }}>
                  <span style={{ fontSize: '2em' }}>1</span>. Chọn giáo viên
                </p>
              </Grid>
              <Grid item>
                <Typography variant="body2">
                  Xem video giới thiệu của giáo viên và đọc nhận xét của các học
                  viên khác.
                </Typography>
              </Grid>
            </Grid>
          </Grid>
        </Container>

        <Container
          container
          item
          justifyContent="space-between"
          alignItems="center"
          style={{ marginTop: '3em', marginBottom: '3em' }}
        >
          <Grid item style={{ order: (matchesMD ? 1 : undefined) }} md={5}>
            <img
              src={schedule}
              alt="Đặt lịch hẹn"
              style={{ maxWidth: '100%' }}
            />
          </Grid>
          <Grid item md={5}>
            <Grid container direction="column">
              <Grid item>
                <p style={{ textTransform: 'uppercase', fontWeight: 600 }}>
                  <span style={{ fontSize: '2em' }}>2</span>. Đặt lịch hẹn
                </p>
              </Grid>
              <Grid item>
                <Typography variant="body2">
                  Đặt lịch hẹn vào thời gian phù hợp với bạn.
                </Typography>
              </Grid>
            </Grid>
          </Grid>
        </Container>

        <Container
          container
          item
          justifyContent="space-between"
          alignItems="center"
        >
          <Grid item md={5}>
            <img
              src={startToLearn}
              alt="Đặt lịch hẹn"
              style={{ maxWidth: '100%' }}
            />
          </Grid>
          <Grid item md={5}>
            <Grid container direction="column">
              <Grid item>
                <p style={{ textTransform: 'uppercase', fontWeight: 600 }}>
                  <span style={{ fontSize: '2em' }}>3</span>. Bắt đầu học
                </p>
              </Grid>
              <Grid item>
                <Typography variant="body2">
                  Kết nối với giáo viên qua các phần mềm video chat và bắt đầu
                  học!
                </Typography>
              </Grid>
            </Grid>
          </Grid>
        </Container>
      </Container>
    </Fragment >
  );
}

export default Landing
